module.exports = __webpack_public_path__ + "img/jpware.9c0f09d9.png";